import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { useActiveFund } from '../../../hooks/useActiveFund';
import { signOutUser } from '../../../services/authService';
import FundSwitcher from './FundSwitcher';

export default function PortalLayout({ children }) {
  const { userProfile } = useAuth();
  const { activeFundId } = useActiveFund();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOutUser();
    navigate('/login');
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)' }}>
      {/* Top navigation */}
      <header style={{
        background: 'var(--color-sidebar)',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        gap: 24,
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
      }}>
        <a
          href="https://intranet.mirepa.global"
          style={{
            fontSize: 12,
            color: 'var(--color-sidebar-text)',
            textDecoration: 'none',
            opacity: 0.65,
            whiteSpace: 'nowrap',
            marginRight: 4,
          }}
        >
          ← Intranet
        </a>
        <span style={{ color: 'var(--color-accent)', fontWeight: 700, fontSize: 14, letterSpacing: '0.3px', marginRight: 8 }}>
          MIA Portal
        </span>
        <FundSwitcher />
        <nav style={{ display: 'flex', gap: 4, flex: 1 }}>
          {[
            { pathname: '/dashboard', label: 'Dashboard' },
            { pathname: '/pipeline', label: 'Pipeline' },
            ...((userProfile?.roles || (userProfile?.role ? [userProfile.role] : []))
              .some(r => ['analyst','head_of_pipeline','cio','md','admin'].includes(r))
              ? [{ pathname: '/analytics', label: 'Analytics' }]
              : []),
          ].map(item => (
            <NavLink
              key={item.pathname}
              to={activeFundId
                ? { pathname: item.pathname, search: `?fund=${activeFundId}` }
                : item.pathname
              }
              style={({ isActive }) => ({
                padding: '6px 14px',
                borderRadius: 6,
                fontSize: 14,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? '#fff' : 'var(--color-sidebar-text)',
                background: isActive ? 'rgba(201,149,42,0.2)' : 'transparent',
                textDecoration: 'none',
                transition: 'all 0.15s',
              })}
            >
              {item.label}
            </NavLink>
          ))}
          {(userProfile?.roles || [userProfile?.role]).includes('admin') && (
            <NavLink
              to="/admin"
              style={({ isActive }) => ({
                padding: '6px 14px',
                borderRadius: 6,
                fontSize: 14,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? '#fff' : 'var(--color-sidebar-text)',
                background: isActive ? 'rgba(201,149,42,0.2)' : 'transparent',
                textDecoration: 'none',
              })}
            >
              Admin Config
            </NavLink>
          )}
        </nav>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 13, color: 'var(--color-sidebar-text)' }}>
            {userProfile?.full_name}
          </span>
          <button
            onClick={handleSignOut}
            style={{
              padding: '5px 12px',
              borderRadius: 6,
              border: '1px solid rgba(255,255,255,0.2)',
              background: 'transparent',
              color: 'var(--color-sidebar-text)',
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            Sign Out
          </button>
        </div>
      </header>
      {/* Main content */}
      <main style={{ padding: '28px 32px', maxWidth: 1280, margin: '0 auto' }}>
        {children}
      </main>
    </div>
  );
}
